'use client'

import { JSX } from 'react'
import { useTranslation } from 'react-i18next'

const ErrorMessage = (): JSX.Element => {
  const { t } = useTranslation('common')
  return <>{t('error')}</>
}

export default ErrorMessage
